/* unplugin-vue-components disabled */import { render } from "./fee2.vue?vue&type=template&id=b3102522"
import script from "./fee2.vue?vue&type=script&lang=js"
export * from "./fee2.vue?vue&type=script&lang=js"

import "./fee2.vue?vue&type=style&index=0&id=b3102522&lang=less"

import exportComponent from "E:\\vuewebpage3\\ydqbyg-dz2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__